// Module
var code = `<div class="alert alert-info">
  Updating center officers will not automatically update group officers. <br/>
  Updating group officers will not automatically update loan level officers.
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Update in:</td>
      <td>
        <select ng-model="\$ctrl.domain"
                ng-options="domain.type as domain.label for domain in \$ctrl.domains"
                ng-change="\$ctrl.onDomainChange()"
                ng-required="true">
        </select>
      </td>
    </tr>
    <tr>
      <td>User:</td>
      <td>
        <multiselect
               items="\$ctrl.userPermissions"
               ng-model="\$ctrl.selectedUserPermission"
               label-property="'label'"
               value-property="'permission'"
               ng-required="true">
  </multiselect>
      </td>
    </tr>
    <tr>
      <td>Content:</td>
      <td>
        <file-upload
          ng-model="\$ctrl.contentFile"
          required
          validate-uploaded
          max-files="1"
          show-file-name="true"
          show-remarks="false"
          enable-webcam="false">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download sample file
    </button>
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-officers/update-officers.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;